module.exports = __webpack_public_path__ + "static/media/logos_squares_ORG_GPAST.0fa2d482.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_ORG_GPAST.png
// module id = 36
// module chunks = 0